/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import MaskingPolicyActions from '@Actions/settings/maskingPolicyActions';
import H3Text from '@Uilib/h3Text';
import { v4 as uuidv4 } from 'uuid';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import { Select } from 'antd';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const MaskingPolicyRuleForm = ({
  data, getMaskingPolicyEditPage, updatedData, maskingPolicyEditPage, callback,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [fieldName, setFieldName] = useState(false);
  const [ruleType, setRuleType] = useState(false);
  const [ruleValue, setRuleValue] = useState(false);
  const [excludeRuleName, setExcludeRuleName] = useState([]);

  useEffect(() => {
    getMaskingPolicyEditPage();
    setExcludeRuleName(data?.map((item) => item.fieldName));
  }, []);

  const ruleTypeOptions = [
  { label: 'Key Substitution', value: 'KEY_SUBSTITUTION' },
  { label: 'Hide', value: 'HIDE' },
  { label: 'Partial', value: 'PARTIAL' },
  { label: 'Substitution', value: 'SUBSTITUTION' },
];


  const addMaskingRule = () => {
    setFormSubmitted(true);

    if (fieldName && ruleType && (ruleType !== 'HIDE' ? ruleValue : true)) {
      const payload = {
        key: uuidv4(),
        fieldName,
        ruleType,
        ruleValue,
      };
      updatedData(payload);
      callback();
    }
  };

  return (
    <Fragment>
      <div className="policy-rule-form__wrapper">
        <div className="policy-rule-form__body-wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24">
              <div className="policy-rule-form__input-row">
                <H3Text
                  text="Field Name"
                  required
                  className="orgFormLabel"
                />
                <div className=" policy-rule-form__input-row__input">
                  <PRZSelect
                    value={fieldName}
                    showSearch
                    filterOption={false}
                    onChange={(value) => {
                      setFieldName(value);
                    }}
                    className={formSubmitted && !fieldName ? 'prz-select__error-border' : ''}
                    style={{
                      borderRadius: '2px',
                      width: '100%',
                      marginBottom: '12px',
                    }}
                  >
                    {maskingPolicyEditPage?.data?.field_names?.filter((item) => !excludeRuleName.includes(item?.value))?.map((columnName) => (
                      <Option
                        key={columnName?.id}
                        value={columnName?.value}
                      >
                        {`${columnName?.name?.split(/[_.]/).join(' ').toProperCase()}`}
                      </Option>
                    ))}
                  </PRZSelect>
                </div>
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="policy-rule-form__input-row">
                <H3Text
                  text="Rule Type"
                  required
                  className="orgFormLabel"
                />
                <div className=" policy-rule-form__input-row__input">
                  <PRZSelect
                    value={ruleType}
                    showSearch
                    filterOption={false}
                    onChange={(value) => {
                      setRuleType(value);
                      setRuleValue('');
                    }}
                    className={formSubmitted && !ruleType ? 'prz-select__error-border' : ''}
                    style={{
                      marginBottom: '12px',
                    }}
                    options={ruleTypeOptions}
                  >
                  </PRZSelect>
                </div>
              </div>
            </div>
            {ruleType && ruleType !== 'HIDE' && (
              <div className="ant-col-md-24">
                <div className="policy-rule-form__input-row">
                  <H3Text
                    text="Rule Value"
                    required
                    className="orgFormLabel"
                  />
                  <div className=" policy-rule-form__input-row__input">
                    {ruleType === 'KEY_SUBSTITUTION' && (
                      <PRZSelect
                        value={ruleValue}
                        showSearch
                        filterOption={false}
                        onChange={(value) => {
                          setRuleValue(value);
                        }}
                        className={formSubmitted && !ruleValue ? 'prz-select__error-border' : ''}
                        style={{
                          marginBottom: '12px',
                        }}
                      >
                        {maskingPolicyEditPage?.data?.field_names?.find((item) => item?.value === fieldName)?.field_value_for_key_substitution?.map((keySubstitute) => (
                          <Option
                            key={keySubstitute?.id}
                            value={keySubstitute?.value}
                          >
                            {`${keySubstitute?.name?.split(/[_.]/).join(' ').toProperCase()}`}
                          </Option>
                        ))}
                      </PRZSelect>
                    )}
                    {(ruleType === 'SUBSTITUTION' || ruleType === 'PARTIAL') && (
                      <H3FormInput
                        value={ruleValue}
                        onChange={(event) => setRuleValue(event.target.value)}
                        type={ruleType === 'PARTIAL' ? 'number' : 'text'}
                        containerClassName="orgInputContainer"
                        labelClassName="orgFormLabel"
                        inputClassName={(formSubmitted && !ruleValue) ? 'orgFormInputError' : 'orgFormInput'}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="policy-rule-form__footer-wrapper">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Add Masking Rule"
            onClick={() => addMaskingRule()}
            customClass="policy-rule-form-submit"
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, MaskingPolicyReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  roles: UserReducers.roles,
  createUserLoading: UserReducers.createUserLoading,
  maskingPolicyEditPage: MaskingPolicyReducers.maskingPolicyEditPage,
  getMaskingPolicyEditPageLoading: MaskingPolicyReducers.getMaskingPolicyEditPageLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getMaskingPolicyEditPage: () => dispatch(MaskingPolicyActions.getMaskingPolicyEditPage()),
});

MaskingPolicyRuleForm.propTypes = {
  callback: PropTypes.any,
  maskingPolicyEditPage: PropTypes.any,
  data: PropTypes.any,
  getMaskingPolicyEditPage: PropTypes.any,
  updatedData: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MaskingPolicyRuleForm));
